module.exports = __webpack_public_path__ + "img/upload-dynamic.78ba39b5.gif";